var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"header-top"},[_c('div',{staticClass:"top-left"}),_c('div',{staticClass:"top-right"},[_c('span',{staticClass:"save-btn",on:{"click":_vm.save}},[_vm._v("保存")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }